module.exports = __webpack_public_path__ + "static/media/errorpage.ed5dbcfb.gif";